import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useCallbackRef from 'hooks/useCallbackRef';
import getAssetType from 'utils/asset/getAssetType';
import { CONTENT_TYPES } from 'utils/asset/constants';
import { validateZipFiles } from './utils';
import { getAssetContentType } from 'screens/AssetEditor/utils';
import Modal from 'components/Modal';
import Card from 'components/Card';
import Panel from 'components/Panel';
import ModalHeadline from 'components/ModalHeadline';
import Landmark from 'components/Landmark';
import Stack from 'components/Stack';
import TextLink from 'components/TextLink';
import FileUploader from './FileUploader';
import { TypeChangeConfirmationModal, PlainZipFileModal } from 'components/UploadFileModals';
var ReplaceFileModal = function ReplaceFileModal(_ref) {
  var isEditMode = _ref.isEditMode,
    isLoading = _ref.isLoading,
    isUploadError = _ref.isUploadError,
    isProcessingError = _ref.isProcessingError,
    isReplacingFile = _ref.isReplacingFile,
    name = _ref.name,
    oldAssetContentType = _ref.oldAssetContentType,
    onUploadAsset = _ref.onUploadAsset,
    onDelete = _ref.onDelete,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'add-new-file-modal-title';
  var modalTitle = t('actions_replace_file');
  if (isUploadError) {
    modalTitle = t('modal_upload_failed_title');
  } else if (isProcessingError) {
    modalTitle = t('modal_processing_failed_title');
  }
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = useState(CONTENT_TYPES.UPLOAD),
    _useState4 = _slicedToArray(_useState3, 2),
    type = _useState4[0],
    setType = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    newAssetContentType = _useState6[0],
    setNewAssetContentType = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isConfirmationModalOpen = _useState8[0],
    setIsConfirmationModalOpen = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isZipModalOpen = _useState10[0],
    setIsZipModalOpen = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isCheckingFile = _useState12[0],
    setIsCheckingFile = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isPlainZipOk = _useState14[0],
    setIsPlainZipOk = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isNewAssetContentTypeOkay = _useState16[0],
    setIsNewAssetContentTypeOkay = _useState16[1];
  var uploadAsset = function uploadAsset(_ref2) {
    var file = _ref2.file,
      type = _ref2.type;
    onUploadAsset({
      file: file,
      type: type
    });
    setIsCheckingFile(false);
  };
  var handleUpload = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
      var file, fileType, data, scormOrMicrositeType, _getAssetType, fileFormat, newContentType;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref3.file;
            setIsCheckingFile(true);
            setFile(file);
            fileType = type; // Check if file is a zip file
            // If yes, check if file is microsite, scorm or plain zip
            _context.next = 6;
            return validateZipFiles(file);
          case 6:
            data = _context.sent;
            // Update type if it is scorm or microsite
            if (data !== null && data !== void 0 && data.isScormOrMicrositeZip) {
              scormOrMicrositeType = data.isScorm ? CONTENT_TYPES.SCORM : CONTENT_TYPES.MICROSITE;
              fileType = scormOrMicrositeType;
              setType(scormOrMicrositeType);
            }

            // Get asset content type for new file
            _getAssetType = getAssetType(file), fileFormat = _getAssetType.fileFormat;
            newContentType = getAssetContentType({
              type: fileType,
              fileFormat: fileFormat
            });
            setNewAssetContentType(newContentType);

            // If the uploaded file is a plain Zip file, ask user for confirmation
            // whether they want to proceed with uploading the file
            if (!(data !== null && data !== void 0 && data.isZip && !(data !== null && data !== void 0 && data.isScormOrMicrositeZip))) {
              _context.next = 14;
              break;
            }
            setIsZipModalOpen(true);
            return _context.abrupt("return");
          case 14:
            if (!(!isNewAssetContentTypeOkay && oldAssetContentType && newContentType !== oldAssetContentType)) {
              _context.next = 17;
              break;
            }
            setIsConfirmationModalOpen(true);
            return _context.abrupt("return");
          case 17:
            // If file is not plain zip and if content type is not changing,
            // proceed with upload of file
            uploadAsset({
              file: file,
              type: fileType
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUpload(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var onConfirmPlainZip = function onConfirmPlainZip() {
    // If we received user confirmation to use plain zip file type in case of plain zip upload,
    // proceed with upload flow
    setIsPlainZipOk(true);

    // If we are replacing an asset file, check if asset file type is the same.
    // If not, get user confirmation to use new file type
    if (!isNewAssetContentTypeOkay && oldAssetContentType && newAssetContentType !== oldAssetContentType) {
      setIsConfirmationModalOpen(true);
      return;
    }

    // If content type is not changing,
    // proceed with upload of plain zip file
    uploadAsset({
      file: file,
      type: type
    });
  };
  var uploadRef = useCallbackRef(function () {
    // If we received user confirmation to use new file type, proceed with upload of new file
    uploadAsset({
      file: file,
      type: type
    });
  });
  useEffect(function () {
    if (isNewAssetContentTypeOkay) {
      uploadRef.current();
    }
  }, [isNewAssetContentTypeOkay, uploadRef]);
  useEffect(function () {
    if (isPlainZipOk && newAssetContentType === oldAssetContentType) {
      uploadRef.current();
    }
  }, [isPlainZipOk, newAssetContentType, oldAssetContentType, uploadRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    id: "add-new-file-modal",
    "aria-labelledby": titleId,
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: modalTitle,
    titleId: titleId,
    subtitle: isReplacingFile ? name : null,
    onClose: onClose
  }), isCheckingFile || isLoading ? /*#__PURE__*/React.createElement(Landmark, {
    icon: "spinner",
    height: 220
  }, t('modal_upload_file_loading')) : /*#__PURE__*/React.createElement(React.Fragment, null, isUploadError && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, t('modal_upload_failed_message', {
    name: name
  }), t('modal_upload_failed_cta'))), isProcessingError && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, t('modal_processing_failed_message', {
    name: name
  }), isEditMode ? t('modal_processing_failed_while_editing_cta') : t('modal_processing_failed_cta'))), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(FileUploader, {
    onSelect: handleUpload
  }))), !isEditMode && isProcessingError && /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    as: "button",
    onClick: onDelete
  }, t('actions_delete_asset'))))), isZipModalOpen && /*#__PURE__*/React.createElement(PlainZipFileModal, {
    fileName: file === null || file === void 0 ? void 0 : file.name,
    onConfirm: onConfirmPlainZip,
    onCancel: function onCancel() {
      setIsCheckingFile(false);
      setType(CONTENT_TYPES.UPLOAD);
      setIsZipModalOpen(false);
    }
  }), isConfirmationModalOpen && newAssetContentType && /*#__PURE__*/React.createElement(TypeChangeConfirmationModal, {
    name: name,
    oldType: oldAssetContentType,
    newType: newAssetContentType,
    onConfirm: function onConfirm() {
      return setIsNewAssetContentTypeOkay(true);
    },
    onCancel: function onCancel() {
      setIsCheckingFile(false);
      setType(CONTENT_TYPES.UPLOAD);
      setIsNewAssetContentTypeOkay(false);
      setIsConfirmationModalOpen(false);
    }
  }));
};
export default ReplaceFileModal;